import slateNodes from '../../../../../../editJournal/constants/slateNodes';

export default (params) => {
  const { editor, preTag, currentOrganization, operation } = params;
  let { updatedOrdinal } = params;

  const {
    value: { document },
  } = editor;
  const { key: currentOrganizationKey } = currentOrganization;

  /**
   * NOTE: This filter might change when dragging is introduced because
   * there would be paragraph at the beginning of the first organization as well
   */
  const { nodes: documentNodes } = document;
  const organizationBlocks = documentNodes.toArray();

  let nextParagraphReached = false;

  organizationBlocks.forEach((organizationBlock) => {
    const { key: organizationBlockKey } = organizationBlock;
    if (
      !nextParagraphReached &&
      organizationBlockKey === currentOrganizationKey
    ) {
      nextParagraphReached = true;
    } else if (nextParagraphReached) {
      updatedOrdinal += 1;
      if (operation === 'delete') {
        const {
          value: { document: currDocument },
        } = editor;

        const roleDetailsParagraph =
          currDocument.getPreviousBlock(organizationBlockKey);
        const { key: roleDetailsParagraphKey } = roleDetailsParagraph;
        const organizationNode = currDocument.getParent(
          roleDetailsParagraphKey,
        );
        const { key: organizationKey, data: organizationData } =
          organizationNode;
        const dataJSON = organizationData.toJSON();
        editor.setNodeByKey(organizationKey, {
          data: {
            ...dataJSON,
            Ordinal: updatedOrdinal,
          },
        });
      } else {
        const {
          value: { document: currDocument },
        } = editor;

        const nextBlock = currDocument.getNextBlock(organizationBlockKey);
        const { key: nextBlockKey, type: nextBlockType } = nextBlock || {};
        if (nextBlock && nextBlockType === `${preTag}_${slateNodes.IMAGE}`) {
          const logo = currDocument.getParent(nextBlockKey);
          const { key: logoKey } = logo;
          const organizationDetails = currDocument.getParent(logoKey);
          const { key: organizationDetailsKey } = organizationDetails;
          const organizationNode = currDocument.getParent(
            organizationDetailsKey,
          );
          const { key: organizationKey, data: organizationData } =
            organizationNode;
          const dataJSON = organizationData.toJSON();

          editor.setNodeByKey(organizationKey, {
            data: {
              ...dataJSON,
              Ordinal: updatedOrdinal,
            },
          });
        }
      }
    }
  });
};
